import { render } from "./TaffyBtnGroup.vue?vue&type=template&id=0be830d6"
import script from "./TaffyBtnGroup.vue?vue&type=script&lang=js"
export * from "./TaffyBtnGroup.vue?vue&type=script&lang=js"

import "./TaffyBtnGroup.vue?vue&type=style&index=0&id=0be830d6&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__